import Icon from './Icon'
import enhance from './enhancers'

const Enhanced = enhance(Icon)

Enhanced.displayName = 'Icon'

export default Enhanced
